import { useId } from "react"

// Small inline-SVG area sparkline used by the per-code list rows and the
// "Scans this week" KPI card. `data` is an array of daily counts (oldest →
// newest). Draws a flat baseline when every value is zero so an idle code
// still renders a clean line rather than collapsing. The gradient id is
// React-stable (useId) so multiple sparklines on the page don't collide —
// never Math.random, which would change between renders.
export default function Sparkline({ data = [], color = "var(--color-voltage)", w = 64, h = 22 }) {
  const id = useId()
  const max = Math.max(1, ...data)
  const step = data.length > 1 ? w / (data.length - 1) : w
  const points = data.map((v, i) => [i * step, h - (v / max) * (h - 3) - 1.5])
  const line = points
    .map((p, i) => `${i ? "L" : "M"}${p[0].toFixed(1)} ${p[1].toFixed(1)}`)
    .join(" ")
  const area = `${line} L ${w} ${h} L 0 ${h} Z`

  return (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      className="block overflow-visible"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.22" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#${id})`} />
      <path
        d={line}
        fill="none"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
